import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { down, up } from 'styled-breakpoints';
import styled from 'styled-components';

import { ThemeColorScheme } from '@rebound/shared-models/retailer/retailer.model';

import LinkItem from './LinkItem';

type LandingPageFooterProps = {
  colorScheme: string;
};

const LandingPageFooter = ({ colorScheme }: LandingPageFooterProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <CopyrightText>
        <span>&copy;&nbsp;</span>
        <span>
          {new Date().getFullYear()} ReBOUND Returns. All Right Reserved. TSB
          Returns Ltd. VAT Number 200932158
        </span>
      </CopyrightText>
      <FooterLinksWrapper>
        <Link href="https://www.reboundreturns.com/privacy-policy/" passHref>
          <LinkItemStyled scheme={colorScheme ?? ThemeColorScheme.Indigo}>
            {t('landing.privacyPolicy') as string}
          </LinkItemStyled>
        </Link>
      </FooterLinksWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: ${(props) => props.theme.colors.white};
  padding: 19px 20px 24px;
  width: 100%;
  display: block;
  box-sizing: border-box;
  border-top: 1px solid ${(props) => props.theme.colors.grayDark2};

  ${up('sm')} {
    padding: 16px 10px;
    display: flex;
    justify-content: space-between;
  }

  ${up('lg')} {
    padding: 26px 140px;
  }
`;

const FooterLinksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 32px;
  row-gap: 8px;

  ${down('xs')} {
    flex-direction: column;
    column-gap: 0;
    row-gap: 16px;
  }
`;

const LinkItemStyled = styled(LinkItem)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

const CopyrightText = styled.div`
  display: flex;
  line-height: 18px;

  ${down('sm')} {
    max-width: 400px;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }

  ${up('sm')} {
    margin-right: 8px;
  }
`;

export default LandingPageFooter;
